import SiteHeader from "@/components/shop/SiteHeader";
import CartDrawer from "@/components/shop/CartDrawer";
import Hero from "@/components/landing/Hero";
import Essentials from "@/components/landing/Essentials";
import ProductBanners from "@/components/landing/ProductBanners";
import TruckBanner from "@/components/landing/TruckBanner";
import WhyMorningSoft from "@/components/landing/WhyMorningSoft";
import Family from "@/components/landing/Family";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import BrandStatement from "@/components/landing/BrandStatement";
import Footer from "@/components/landing/Footer";

export default function Home() {
  return (
    <div className="relative bg-white text-slate-900 overflow-x-clip" data-testid="home-page">
      <SiteHeader />
      <CartDrawer />
      <main>
        <Hero />
        <Essentials />
        <ProductBanners />
        <TruckBanner />
        <WhyMorningSoft />
        <Family />
        <Testimonials />
        <Faq />
        <BrandStatement />
      </main>
      <Footer />
    </div>
  );
}
